import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22HomeDashboard.tsx%22,%22import%22:%22Gamja_Flower%22,%22arguments%22:[{%22weight%22:%22400%22,%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22fallback%22:[%22serif%22]}],%22variableName%22:%22gamja%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Gamja Flower', serif",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
